import styled from 'styled-components'

export const IconWrapper = styled.span`
    color: ${(props) => props.theme.colors.brand.primary};

    svg {
        fill: currentColor;
    }
`
